//--------------- IMPORTAÇÃOES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";



//--------------- FUNÇÃO ASSÍNCRONA CREATE USER SERVICE ---------------//
// Responsável por requisitar à API a Criação do Usuário
export default async function createUserService(payload) {
    if (!payload.nome || !payload.email || (!payload && !payload.senha)) {
        toast.warn("Preencha todos os campos obrigatórios");
        return false;
    }
    try {
        await api.post("/usuarios", payload);
        toast.success("Usuário criado com sucesso");
        return true;
    } catch (err) {
        toast.error("Erro ao criar usuário")
        return false;
    }
}